<script>
export default {
    name: "SupplierInvoiceForm",
    data() {
      return {
        wizardPage: 1,
        invoiceDetails: {
                currencyID: null,
                invoiceNo: "",
                userName: this.$root.username,
                exchangeRate: 1,
                sysDate: window.moment().format('YYYY-MM-DD'),
                grnQty: 0,
                orderedQty: 0,
                lpoRef: "",
                grnRef: "",
                bonus: 0,
                tax: 0,
                discount: 0,
                unitPrice: 0,
                posted: false,
                valid: false,
                detailID: 0,
                description: "",
                deliveredBy: "",
                wayBillNo: "NA",
                extRef:""
            },
            invoice:[]
      };
    },

    components: {

      "invoice-details-form": () => import('./wizard/InvoiceDetails.vue'),
      "items-details-form": () => import('./wizard/ItemDetails.vue'),
    },
    mounted(){
        this.$root.loading = true;
      
      this.fetchSpecificInvoice();
      
    },
//     watch:{
// "invoiceDetails.invoiceNo"(){
// if(this.invoice.length>0){
//         this.invoiceDetails.invoiceNo=this.invoice[0].invoiceNo;
//         this.invoiceDetails.extRef=this.invoice[0].extRef;
//       }
//       else{
//          this.invoiceDetails.invoiceNo=this.invoice.length;
//         this.invoiceDetails.extRef='-';
     
//       }
// }
   // },
    methods: {

      refreshData() {
  
        this.invoiceDetails = {
                currencyID: null,
                invoiceNo: "",
                userName: this.$root.username,
                exchangeRate: 1,
                sysDate: window.moment().format('YYYY-MM-DD')
            };
  
        this.wizardPage = 1;
      },
      fetchSpecificInvoice() {
let url=`SupplierInvoice/SpecificInvoice`;
url+=`?InvoiceNo=${this.$router.currentRoute.params.invoiceNo}`;
            return this.$accountsHttp.get(url).then(response => {
                this.invoice = response.data;
                  this.$root.loading = false;
      if(this.invoice.length>0){
        this.invoiceDetails.invoiceNo=this.invoice[0].invoiceNo;
        this.invoiceDetails.supplierID=this.invoice[0].supplierID;
        this.invoiceDetails.extRef=this.invoice[0].extRef;
        this.invoiceDetails.txnDate=this.invoice[0].txnDate.substring(0, 10);
        this.invoiceDetails.dueDate=this.invoice[0].dueDate.substring(0, 10);
        this.invoiceDetails.ref=this.invoice[0].ref;
        this.invoiceDetails.memo=this.invoice[0].memo;
      }
      // else{
      //    this.invoiceDetails.invoiceNo=this.invoice.length;
      //   this.invoiceDetails.extRef='-';
     
      // }
            }).catch(() => {  this.$root.loading = false;});
        },
    },
}
</script>

<template>
<tail-base-layout>
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
          <h5 class="font-medium text-sm">Initiate Supplier Invoice</h5>
        </template>
        <template v-slot:card-body>
            <div class="flex flex-wrap w-full">
              <keep-alive>
                <invoice-details-form :invoiceDetails="invoiceDetails" @itemDetails="wizardPage = 2" v-if="wizardPage == 1"/>
                <items-details-form @refreshData="refreshData" :invoiceDetails="invoiceDetails" @invoiceDetails="wizardPage = 1" v-if="wizardPage == 2"/>
              </keep-alive> 
            </div>
        </template>
        <template v-slot:card-footer>
           <div class="w-full text-right">
             <router-link :to="{ name: `suppliers-dashboard.invoice-list.index` }" class="btn-sm btn-danger text-xs rounded"><i class="fa fa-caret-left"></i> Back</router-link>
           </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>
